import * as React from 'react';
import {Col, Row} from 'react-bootstrap';
import {setSuccess} from '../../../actions/loadingActions';
import {UserModel} from '../../../model/UserModel';
import {Async} from '../Async';
import {ErrorPage} from '../ErrorPage';
import {Loader} from '../Loader/Loader';
import './listPage.scss';
import {ModuleModel} from '../../../model/ModuleModel';
import {PerfectScrollbar} from '../PerfectScrollbar';
import {dispatch} from '../../../utils/generalUtils';
import {actions} from 'react-redux-form';
import {store} from '../../../store';
import {CategoryFilter} from '../../Modules/CategoryFilter';

type ModelInstances = UserModel | ModuleModel;

export interface IListPageProps {
    identifier?: string;
    instances: ModelInstances[];
    listItemComponent: React.ComponentClass<{
        instance?: ModelInstances, index?: number,
        listItemProp?: string, onClick?: Function,
        className?: string; onRowSelect?: (id: string, index: string) => void;
    }>;
    searchBy: string[];
    pageHeadings: string[];
    promise: (...args: any[]) => any;
    cols: number[];
    searchPlaceHolder?: string;
    instanceOf?: string;
    emptyListMessage?: string;
    style?: React.CSSProperties;
    defaultSort?: number;
    chartComponents?: JSX.Element;
    height?: string;
    chartTitle?: string;
    chartFilter?: JSX.Element | JSX.Element[];
    filterBy?: string;
    listItemProp?: string;
    onFilter?: Function;
    isSearchable?: boolean;
    listFooter?: React.ComponentClass<{ instances: ModelInstances[], index: number, onClose: Function, id: string }>;
    Category?: string;
    SubCategory?: string;
}

export interface IListPageState {
    searchInput: string;
    id: string;
    index?: number;
    showFooter: boolean;
    filteredInstances: ModelInstances[];
    showFooterModal: boolean;
    isScrolled: boolean;
    isAscending: boolean;
    clickedIndex: string[];
    formIndex: number[];
}

export class ListPage extends React.PureComponent<IListPageProps, IListPageState> {
    constructor(props: IListPageProps) {
        super(props);
        this.state = {
            id: '', isScrolled: false,
            searchInput: '', filteredInstances: [], showFooter: false, showFooterModal: false,
            isAscending: false, clickedIndex: null, formIndex: null
        };
    }

    public handleRowSelect = (id: string, index: string) => {
        const selectedIds = store.getState().forms.selectedListItems.listItems;
        if (selectedIds.indexOf(id) > -1) {
            const formIndex = selectedIds.indexOf(id);
            dispatch(actions.remove('forms.selectedListItems.listItems', formIndex));
            return;
        }
        dispatch(actions.push('forms.selectedListItems.listItems', id));
    }

    public renderListItems = () => {
        const {
            instances, listItemComponent, pageHeadings, cols,
            searchBy, instanceOf, filterBy, emptyListMessage, listItemProp
        } = this.props;

        const {searchInput} = this.state;
        // const searchInput = 'Safe Connect';
        const ListItem = listItemComponent;
        const filteredInstances = [];
        const EmptyList = () => <div className="empty-list">
            {`${emptyListMessage} ${searchInput ? 'for ' + searchInput : ''}`}</div>;
        if (searchInput.length > 0) {
            instances.forEach(instance => {
                searchBy.forEach(searchText => {
                    if (instance.props[searchText] &&
                        instance.props[searchText].toString().toLowerCase().indexOf(searchInput.toLowerCase()) > -1) {
                        if (filteredInstances.indexOf(instance) < 0) {
                            filteredInstances.push(instance);
                            return;
                        }
                    }
                });
            });
        }
        if (filteredInstances.length > 0 || searchInput.length > 0) {
            return <div> {filteredInstances.length > 0 ? filteredInstances.map((instance, index) => {
                return <div key={index}>
                    <ListItem
                        className="form-list-item"
                        index={index + 1}
                        listItemProp={listItemProp}
                        instance={instance}
                        onRowSelect={this.handleRowSelect}
                    />
                </div>;
            }) : <EmptyList/>}</div>;
        }

        return <div>{instances.length > 0 ? instances.map((instance, index) => {
            return <div key={index}>
                <ListItem
                    className="form-list-item"
                    index={index + 1}
                    listItemProp={listItemProp}
                    onRowSelect={this.handleRowSelect}
                    instance={instance}
                />
            </div>;
        }) : <EmptyList/>}</div>;
        // return instances;
    }

    public sortList = (sortFor: string) => {
        const {isAscending, filteredInstances} = this.state;
        let sortedListItems = [];
        const stringTypeColsToSort = ['modulesCount', 'ModuleName', 'Name', 'Category', 'FirstName', 'moduleName', 'userName', 'certificateName', 'AccessLevel', 'TrainingDuration', 'DateCompleted', 'Completed', 'JobTitle', 'Active', 'organizationName', 'RequestedDate', 'Status'];
        const isStringTypeCol = stringTypeColsToSort.filter((col: string) => {
            return col === sortFor;
        });
        if (!isAscending) {
            if (isStringTypeCol.length) {
                sortedListItems = filteredInstances.length > 0 ? filteredInstances : this.props.instances;
                sortedListItems = sortedListItems.sort((a, b) => {
                    const textA = a.props[sortFor];
                    const textB = b.props[sortFor];
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            } else {
                filteredInstances.length > 0 ?
                    sortedListItems = filteredInstances.sort((i, j) => {
                        return new Date(j.props[sortFor].replace(/-/g, '/')).getTime() - new Date(i.props[sortFor].replace(/-/g, '/')).getTime() as any;
                    })
                    :
                    sortedListItems = this.props.instances.sort((i, j) => {
                        return new Date(j.props[sortFor].replace(/-/g, '/')).getTime() - new Date(i.props[sortFor].replace(/-/g, '/')).getTime() as any;
                    });
            }

        } else {
            if (isStringTypeCol.length) {
                sortedListItems = filteredInstances.length > 0 ? filteredInstances : this.props.instances;
                sortedListItems = sortedListItems.sort((a, b) => {
                    const textA = a.props[sortFor];
                    const textB = b.props[sortFor];
                    return (textA > textB) ? -1 : (textA < textB) ? 1 : 0;
                });
            } else { 
                filteredInstances.length > 0 ?
                    sortedListItems = filteredInstances.sort((i, j) => {
                        return new Date(i.props[sortFor].replace(/-/g, '/')).getTime() - new Date(j.props[sortFor].replace(/-/g, '/')).getTime() as any;
                    })
                    :
                    sortedListItems = this.props.instances.sort((i, j) => {
                        return new Date(i.props[sortFor].replace(/-/g, '/')).getTime() - new Date(j.props[sortFor].replace(/-/g, '/')).getTime() as any;
                    });
            }

        }
        if (sortedListItems.length) {
            this.setState({
                filteredInstances: sortedListItems,
                isAscending: !this.state.isAscending
            });
        }
    }

    public renderPageHeadings = () => {
        const {pageHeadings, cols, searchBy, defaultSort} = this.props;
        return <Row
            id="listHeadings"
            className={this.state.isScrolled ? 'list-headings list-headings-scrolled' : 'list-headings'}
        >
            {pageHeadings.map((heading: string, index) => {
                if (heading.toLowerCase() === '#') {
                    return <Col key={index}
                                className="heading serial" xs={cols[index]} sm={cols[index]}>{heading}</Col>;
                } else {
                    return <Col
                        key={index}
                        className={heading.toLowerCase() === 'delete' ? "heading del-heading" : "heading"}
                        sm={cols[index]}
                        xs={cols[index]}
                    >
                        {/* {heading}
                        &nbsp; */}
                        {
                            [<span key={index + 50}>
                                {heading}
                                &nbsp;
                            </span>,
                                heading.toLowerCase() !== 'options' && heading.toLowerCase() !== 'id' && heading.toLowerCase() !== 'edit' && heading.toLowerCase() !== 'delete' && heading.toLowerCase() !== 'download' && <i
                                    key={index + 20}
                                    onClick={() => this.sortList(searchBy[index])}
                                    className="fa fa-sort"
                                    style={{color: 'white'}}
                                    aria-hidden="true"
                                />]
                        }
                    </Col>;
                }
            })}
        </Row>;
    }

    public isMobileDevice = () => {
        return navigator.userAgent.toString().indexOf('Mobile') > -1;

    }
    public handleSubmit = async (values: IListPageProps ) => {
        // if (isFormEmpty(values)) {
        //     return;
        // }
        // values.Category = this.state.selectedLevel;
        let searchInputs = '';
        searchInputs = values.Category.toString();
        await this.setState({
            searchInput: searchInputs
        });
        return;
        // return await updateOrgInfo(values, this.refs.orgData.orgPic, this.props.history);
    }

    public renderListPage = () => {
        const {
            instances, isSearchable,
            listItemComponent, pageHeadings, cols, chartTitle, chartFilter, filterBy
        } = this.props;
        const {filteredInstances, searchInput} = this.state;
        const ListFooter = this.props.listFooter;
        return <div className="list-page" style={this.props.style}>
            {chartTitle == 'TrainingModuleList' || chartTitle == 'CertificateList' ?
            <div className='sel-placement'>
            <CategoryFilter
                id="CategoryFilter"
                ref="CategoryFilter"
                Category={this.props.Category}
                model="forms.categoryFilterForm" 
                onSubmit={this.handleSubmit}
            />
            </div>
            :''}
            {isSearchable ? <div className="search-container">
                <i className="fa fa-search" aria-hidden="true"/>
                <input
                    className="search-input"
                    type="text"
                    onChange={e => this.setState({searchInput: e.target.value})}
                    placeholder={this.props.searchPlaceHolder}
                />
            </div> : ''}
            {this.renderPageHeadings()}
            <PerfectScrollbar className="list-page-container">
                <Async
                    identifier={this.props.identifier}
                    promise={() => setSuccess(this.props.identifier)}
                    loader={<Loader type="async"/>}
                    error={<ErrorPage/>}
                    content={this.renderListItems()}
                />
            </PerfectScrollbar>
            {/* {!this.isMobileDevice() && this.props.listFooter ?
                <div className={this.state.showFooter ? 'slider-bottom-visible' : 'slider-bottom-hidden'} >
                    <ListFooter onClose={() => this.setState({ showFooter: false })}
                        instances={instances} index={this.state.index} id={this.state.id} />
                </div> : ''} */}
        </div>;
    }

    public render() {
        return <Async
            identifier={'ListPageAll'}
            promise={() => setSuccess('ListPageAll')}
            loader={< Loader type="async"/>}
            error={< ErrorPage/>}
            content={this.renderListPage()}
        />;
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/reusableComponents/ListPage/index.tsx